module.exports = __webpack_public_path__ + "img/autoral.9a94120f.svg";